import React from 'react';
export function Footer() {
  return <footer className="bg-navy py-6 sm:py-8 px-5 text-center border-t border-white/8" data-id="element-110">
      <p className="text-white/40 text-[10px] sm:text-sm mb-1.5 sm:mb-2" data-id="element-111">
        🩺 <strong className="text-white/70" data-id="element-112">LA CONSULTA PERFECTA™</strong> —
        El sistema de comunicación N°1 para veterinarios en Argentina.
      </p>
      <p className="text-white/40 text-[10px] sm:text-sm" data-id="element-113">
        contacto@solucionesya.shop ·{' '}
        <a href="#" className="text-gold-light hover:underline" data-id="element-114">
          @solucionesya.shop
        </a>{' '}
        · solucionesya.shop
      </p>
      <p className="text-white/40 text-[10px] sm:text-sm mt-2 sm:mt-3" data-id="element-115">
        © solucionesya.shop™ 2026 — Todos los derechos reservados.
      </p>
    </footer>;
}